import React, { memo } from 'react';
import { useTheme } from 'emotion-theming';
export var PriceQuotes = /*#__PURE__*/memo(function (_ref) {
  var _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? '#003B5C' : _ref$stroke,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '88px' : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '125px' : _ref$width;

  var _useTheme = useTheme(),
      secondary = _useTheme.colors.secondary;

  return /*#__PURE__*/React.createElement("svg", {
    version: "1.1",
    width: width,
    height: height,
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 54.1 67",
    style: {
      enableBackground: 'new 0 0 54.1 67'
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: secondary,
    d: "M52.4,51.3c-0.1-6.3,0.5-17.4,0.4-21.6c-0.1-4.8-0.2-9.7-0.3-14.5c0-3.9,0.3-9.7-0.6-13.4h-7.8v49.6H52.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: stroke,
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: "1.5,65.5 37.6,65.5 52.6,50.4 52.6,1.5 1.5,1.5 \t\t"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: stroke,
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: "52.6,50.4 37.6,50.4 37.6,65.5 \t\t"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: stroke,
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M20.1,40c0,3.6,3.1,6.5,7,6.5c3.9,0,7-2.9,7-6.5c0-3.6-3.1-6.5-7-6.5c-3.9,0-7-2.9-7-6.5c0-3.6,3.1-6.5,7-6.5 c2.2,0,4.1,0.9,5.4,2.4"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: stroke,
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: "26.8",
    y1: "16.9",
    x2: "26.8",
    y2: "50.1"
  })));
});